import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=51156ce6&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=51156ce6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51156ce6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51156ce6')) {
      api.createRecord('51156ce6', component.options)
    } else {
      api.reload('51156ce6', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=51156ce6&scoped=true", function () {
      api.rerender('51156ce6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/attendance_manage/check_in_details_report/components/edit.vue"
export default component.exports